<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781429976374_toc01#toctitle1" id="title1"><span><strong class="b">Acknowledgments</strong></span></a></div>
<div class="p"><span>I could probably fill a book with the names of all the people who have taught me invaluable lessons about life in Paris over the years. For brevity’s sake, I will thank just a few great friends who helped make this novel possible: Ted Joans and Laura Corsiglia, C. K. Williams and Catherine Mauger, Christophe Ortega, Maggie Doherty, David Harmon, Velma Bury, Tannie Stovall, Odile Hellier, James Emanuel, Hart Leroy Bibbs, Bob Swaim, Craig Preston and Nicole Johnson.</span></div>
<div class="p-c"><span><em class="i">Merci mille fois à tous.</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429976374_ack01.vue?40ded356